<template>
	<div>
		<div class="card mb-0 shadow" v-if="!editar_oficio">
			<div class="card-body">
				<div class="tab-content">
					<div class="animate__animated animate__fadeIn">
						<div class="row">
							<div class="col-12">
								<h4 class="font-weight-bold">Ofícios</h4>
							</div>
							<div class="col-md-12">
								<div v-if="!nova_Oficio" class="animate__animated animate__fadeIn">
									<div class="row" v-if="!loading">
										<div class="col-12">
											<div class="d-flex align-items-center justify-content-between mb-4">
												<div>
													<button class="btn btn-sm btn-primary" @click="nova_Oficio = true">
														<i class="fas fa-plus-square" />
														{{ $t("Cadastrar") }}
													</button>
													<button
														class="btn btn-sm btn-primary"
														@click="$bvModal.show('relacionar-model')"
													>
														<i class="mdi mdi-connection" />
														{{ $t("Relacionar com um existente") }}
													</button>
												</div>
												<div>
													<div class="input-group mb-3">
														<b-input
															:placeholder="$t('Type to search')"
															class="form-control search-input"
															type="text"
															v-model="search"
															v-on:change="getOficios"
															aria-describedby="input-search"
														/>
														<div class="input-group-append" role="button">
															<span class="input-group-text" id="input-search"
																><i class="fas fa-search search-icon"
															/></span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<load mode="table" v-if="loading" />
										<div class="col-12" v-else>
											<ListOficios
												:itens="OficiosList"
												:pagination="pagination"
												:page.sync="page"
												:porpagina.sync="perPage"
												@changePage="changePage"
												@reload="getOficios"
												@editar="
													oficioSelected = $event;
													editar_oficio = true;
												"
											/>
										</div>
									</div>
								</div>
								<NovoOficio
									v-else
									@voltar="nova_Oficio = false"
									:familia="familia"
									:morph="{ id: acompanhamento.id, type: 'Paf' }"
									@reload="
										getOficios();
										nova_Oficio = false;
									"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<EditarOficio
			v-else
			:morph="true"
			:morph-oficio-id="oficioSelected"
			@voltar="editar_oficio = false"
		/>
		<ModalRelacionar
			table="oficios"
			text="Ofício"
			:paf-id="acompanhamento.id"
			label="Digite ou selecione o Número/Ano"
			@reload="getOficios"
		/>
	</div>
</template>
<script>
import NovoOficio from "../../../../../../Oficio/Resources/assets/js/Add";
import EditarOficio from "../../../../../../Oficio/Resources/assets/js/Edit";
import ListOficios from "./lista/ListOficios";
import ModalRelacionar from "../ModalRelacionar";
export default {
	props: ["acompanhamento"],
	components: {
		NovoOficio,
		EditarOficio,
		ModalRelacionar,
		ListOficios,
	},
	name: "Oficios",
	metaInfo() {
		return {
			title: this.$i18n.t("Oficios"),
		};
	},
	data() {
		return {
			oficioSelected: "",
			editar_oficio: false,
			nova_Oficio: false,
			TipoOficiosList: [],
			OficiosList: [],
			page: 1,
			search: "",
			perPage: 10,
			loading: true,
			loading: true,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
		};
	},
	mounted() {
		this.getOficios();
	},
	methods: {
		getOficios() {
			this.loading = true;
			axios
				.get("api/dashboard/oficios", {
					params: {
						id: this.$route.query.familia_id,
						morph_type: "Paf",
						morph_id: this.acompanhamento.id,
						page: this.page,
						search: this.search,
						perPage: this.perPage,
					},
				})
				.then((response) => {
					this.OficiosList = response.data.table.data;
					this.pagination = response.data.pagination;

					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getOficios();
					} else {
						this.loading = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getOficios();
			}
		},
		redirectOficio(id) {
			this.$router.push(`/dashboard/oficios/edit/${id}`);
		},
	},
};
</script>

